var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchToAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14V13.35C2 13.01 2.16 12.69 2.41 12.54C4.1 11.53 6.03 11 8 11C8.03 11 8.05 11 8.08 11.01C8.18 10.31 8.38 9.64 8.67 9.03C8.45 9.01 8.23 9 8 9C5.58 9 3.32 9.67 1.39 10.82C0.51 11.34 0 12.32 0 13.35V16H9.26C8.84 15.4 8.51 14.72 8.29 14H2Z",
    fill: "rgba(0, 0, 0, 0.54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2Z",
    fill: "rgba(0, 0, 0, 0.54)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7499 12C18.7499 11.78 18.7199 11.58 18.6899 11.37L19.8299 10.36L18.8299 8.63L17.3799 9.12C17.0599 8.85 16.6999 8.64 16.2999 8.49L15.9999 7H13.9999L13.6999 8.49C13.2999 8.64 12.9399 8.85 12.6199 9.12L11.1699 8.63L10.1699 10.36L11.3099 11.37C11.2799 11.58 11.2499 11.78 11.2499 12C11.2499 12.22 11.2799 12.42 11.3099 12.63L10.1699 13.64L11.1699 15.37L12.6199 14.88C12.9399 15.15 13.2999 15.36 13.6999 15.51L13.9999 17H15.9999L16.2999 15.51C16.6999 15.36 17.0599 15.15 17.3799 14.88L18.8299 15.37L19.8299 13.64L18.6899 12.63C18.7199 12.42 18.7499 12.22 18.7499 12ZM14.9999 14C13.8999 14 12.9999 13.1 12.9999 12C12.9999 10.9 13.8999 10 14.9999 10C16.0999 10 16.9999 10.9 16.9999 12C16.9999 13.1 16.0999 14 14.9999 14Z",
    fill: "rgba(0, 0, 0, 0.54)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchToAdmin);
export default __webpack_public_path__ + "static/media/switch-to-admin.2dac98327febe701678814e17918a135.svg";
export { ForwardRef as ReactComponent };